import ApolloClient from 'apollo-boost';

const apolloClient = new ApolloClient({
  uri: process.env.API_BASE_URL,
  request: operation => {
    const token = localStorage.getItem('token');
    operation.setContext({
      headers: {
        authorization: token || ''
      }
    });
  },
  onError: ({networkError, graphQLErrors}) => {
    if (graphQLErrors) {
      console.warn('graphQLErrors', graphQLErrors);
    }
    if (networkError) {
      console.warn('networkError', networkError);
    }
  }
});

export default apolloClient;
